__turbopack_context__.v({
  "categoryLabel": "xIqhqq_categoryLabel",
  "categoryLabelWrapper": "xIqhqq_categoryLabelWrapper",
  "categoryRow": "xIqhqq_categoryRow",
  "categoryThumbnail": "xIqhqq_categoryThumbnail",
  "categoryWrapper": "xIqhqq_categoryWrapper",
  "closeButton": "xIqhqq_closeButton",
  "container": "xIqhqq_container",
  "gridRow": "xIqhqq_gridRow",
  "headerCell": "xIqhqq_headerCell",
  "headerRow": "xIqhqq_headerRow",
  "itemName": "xIqhqq_itemName",
  "itemRow": "xIqhqq_itemRow",
  "itemTextValue": "xIqhqq_itemTextValue",
  "itemValue": "xIqhqq_itemValue",
  "itemsContainer": "xIqhqq_itemsContainer",
  "mobileBreak": "xIqhqq_mobileBreak",
  "separator": "xIqhqq_separator",
  "tableBody": "xIqhqq_tableBody",
  "tableBodyContent": "xIqhqq_tableBodyContent",
});
